import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { AppConfig } from 'src/app/config';
import { moduli } from '../../config';
import { DjelatniciService } from './djelatnici.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-djelatnici',
  templateUrl: './djelatnici.component.html',
  styleUrls: ['./djelatnici.component.scss'],
  providers: [DjelatniciService],
})
export class DjelatniciComponent implements OnInit {
  djelatnici = [];
  organi = [];
  radnaMjesta = [];
  partneri = [];
  poruka: string;
  djelatnikFormaPoruka: string;
  djelatnikPopupVisible: boolean = false;
  obrisiDjelatnikaPopupVisible: boolean = false;
  korisnickoIme: string;
  lozinka: string;
  ime: string;
  email: string;
  status = [
    { id: 0, naziv: 'Neaktivan' },
    { id: 1, naziv: 'Aktivan' },
  ];
  aktivan: string;
  organ: string;
  organNaziv: string;
  radnoMjesto: number;
  oib: string;
  admin = [
    { id: 0, naziv: 'Ne' },
    { id: 1, naziv: 'Da' },
  ];
  adminStatus: string;
  vrsta = [
    { id: 'K', naziv: 'Kupac' },
    { id: 'P', naziv: 'Prodavatelj' },
  ];
  rukovodeci: boolean = false;
  rukovodeci_vr: any = 0;
  vrstaStatus: string;
  partnerId: number;
  firmaId: number;
  popisAktivnih: boolean;
  cijenaRada: number;
  napomena: string;
  upload_URL: any = AppConfig.ipAddress + 'upload_djelatnik_xls';

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  idfirma: any;
  idSecUser: any; //PRIJAVLJENI KORISNIK
  idkorisnik2: any; //ID OD ODABRANOG DJELATNIKA
  sveKorisnickeGrupe: any = []; //LJUDSKI RESURSI, LJUDSKI RESURSI ADMIN, AKCIJA, AKCIJA ADMIN...
  idGrupa: any; //ID OD ODABRANE GRUPE iz sveGrupe
  sviModuli: any = []; //RASPORED LJUDI, DJELATNICI, GODIŠNJI ITD...

  aktivniDjelatnici: any = [];
  djelatnikAktivan: string;

  closeButtonOptions: any;
  popupVisible: boolean = false;

  dozvoli_export: boolean = false;
  podacizaPDF: any = [];
  docDefinition: any = [];
  prikaziGumb = false;

  constructor(private service: DjelatniciService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    this.idSecUser = localStorage.getItem('idsecuser');
    this.idfirma = localStorage.getItem('firma');

    this.closeButtonOptions = {
      text: 'Close',
      onClick(e) {
        this.popupVisible = false;
      },
    };

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().djelatnici;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiDjelatnike();
    this.dohvatiMjestoRada();
    this.dohvatiOrgan();
    // this.dohvatiPartnere();
  }

  numberToHRK(number) {
    return new Intl.NumberFormat('hr-HR', {
      style: 'currency',
      currency: 'HRK',
    }).format(number);
  }

  numberToEUR(number) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(number);
  }

  // ========== DJELATNICI ==========
  dohvatiDjelatnike() {
    this.popisAktivnih = true;
    this.prikaziGumb = false;
    this.dozvoli_export = false;
    // this.poruka = 'Učitavanje...';
    this.service.dohvatiDjelatnike({}).subscribe((res) => {
      //console.log(res);
      this.djelatnici = [];
      this.podacizaPDF = [];
      if (res.success == true) {
        // if (res.data.length == 0) {
        //   this.poruka = 'Nema rezultata!';
        // } else {
        //   this.poruka = 'Učitavanje...';
        // }
        for (let djelatnik of res.data) {
          this.djelatnici.push({
            idDjelatnik: djelatnik.idsec_users,
            aktivan: djelatnik.active,
            idFirma: djelatnik.firma_id_firma,
            idPartner: djelatnik.partner_pa_id,
            idPoslovnica: djelatnik.poslovnicapartnera_pp_id,
            korisnickoIme: djelatnik.login,
            lozinka: djelatnik.pswd,
            admin: djelatnik.priv_admin,
            ime: djelatnik.name,
            oib: djelatnik.dj_oib,
            email: djelatnik.email,
            radnoMjesto: djelatnik.dj_mjestorada,
            organ: djelatnik.dj_organ,
            organNaziv: djelatnik.dj_organnaziv,
            vrsta: djelatnik.usr_vrsta,
            cijenaRada: djelatnik.dj_cijenarada,
            cijenaRadaPrikaz: djelatnik.dj_cijenarada
              ? this.numberToHRK(djelatnik.dj_cijenarada)
              : '',
            rukovodeci: djelatnik.dj_rukovodeci,
            napomena: djelatnik.napomena,
          });
        }
        // console.log(this.djelatnici);
        if (res.data.length > 0) {
          this.dozvoli_export = true;
          this.prikaziGumb = true;
        }else{
          this.dozvoli_export = false;
          this.prikaziGumb = false;
        }

        //za ispis pocetak
        let n = 1;
        this.podacizaPDF.push([
          {text: 'R.b.', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]}, 
          {text: 'ID', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Korisničko ime', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Ime', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Cijena satnice', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Organ', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Napomena', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]}
        ]); 
        this.djelatnici.forEach((item) =>{
          //console.log(item);
          this.podacizaPDF.push([
            {text: n+'.', border: [false, false, false, false]},
            {text: item.idDjelatnik, border: [false, false, false, false], alignment: 'right'},
            {text: item.korisnickoIme, border: [false, false, false, false]},
            {text: item.ime, border: [false, false, false, false]},
            {text: item.cijenaRadaPrikaz, border: [false, false, false, false], alignment: 'right'},
            {text: item.organNaziv, border: [false, false, false, false]},
            {text: item.napomena, border: [false, false, false, false]}
          ]);
          n++;
        });
        //za ispis kraj

      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  ispisi(){

    let status;
    if (this.popisAktivnih) {
      status = 'aktivni';
    }else{
      status = 'neaktivni';
    }

    this.docDefinition = {
      pageMargins: [10, 40, 10, 50],

      footer:function(currentPage, pageCount) {
        return [{ text:  currentPage.toString() + ' / ' + pageCount, alignment: 'right', fontSize: 8, margin:[0, 40, 40, 0] }]
      },

      content:[
        {
          stack:[
            {text: 'DJELATNICI' + ' ' + status, style: 'subheader1'},
          ],
          style: 'header'
        },
        {
          style: 'tablicasadrzaja',
          table:{
            headerRows: 1,
            widths: [25,30,'auto','auto',60,'auto','auto'],
            body: 
              this.podacizaPDF,
          },
        },
      ],
      styles:{
        header:{
          fontSize: 18,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 10]
        },
        subheader:{
          fontSize: 12,
          alignment: 'left',
        },
        subheader1:{
          fontSize: 14,
          alignment: 'center',
        },
        tablicasadrzaja:{
          fontSize: 8,
          margin: [0, 10, 0, 0]
        },
        tableFooter: {
          margin: [0, 10, 0, 0],
          bold: true,
        }
      }   
    }
    pdfMake.createPdf(this.docDefinition).open();
  }

  djelatniciPrava() {
    this.router.navigate(['/djelatnikPrava']);
  }

  dohvatiNeaktivneDjelatnike() {
    this.popisAktivnih = false;
    this.prikaziGumb = false;
    this.dozvoli_export = false;
    // this.poruka = 'Učitavanje...';
    this.service.dohvatiNeaktivneDjelatnike({}).subscribe((res) => {
      //console.log(res);
      this.djelatnici = [];
      this.podacizaPDF = [];
      if (res.success == true) {
        // if (res.data.length == 0) {
        //   this.poruka = 'Nema rezultata!';
        // } else {
        //   this.poruka = 'Učitavanje...';
        // }
        for (let djelatnik of res.data) {
          this.djelatnici.push({
            idDjelatnik: djelatnik.idsec_users,
            aktivan: djelatnik.active,
            idFirma: djelatnik.firma_id_firma,
            idPartner: djelatnik.partner_pa_id,
            idPoslovnica: djelatnik.poslovnicapartnera_pp_id,
            korisnickoIme: djelatnik.login,
            lozinka: djelatnik.pswd,
            admin: djelatnik.priv_admin,
            ime: djelatnik.name,
            oib: djelatnik.dj_oib,
            email: djelatnik.email,
            radnoMjesto: djelatnik.dj_mjestorada,
            organ: djelatnik.dj_organ,
            organNaziv: djelatnik.dj_organnaziv,
            vrsta: djelatnik.usr_vrsta,
            cijenaRada: djelatnik.dj_cijenarada,
            cijenaRadaPrikaz: djelatnik.dj_cijenarada
              ? this.numberToHRK(djelatnik.dj_cijenarada)
              : '',
            rukovodeci: djelatnik.dj_rukovodeci,
            napomena: djelatnik.napomena,
          });
        }
        // console.log(this.djelatnici);
        if (res.data.length > 0) {
          this.dozvoli_export = true;
          this.prikaziGumb = true;
        }else{
          this.dozvoli_export = false;
          this.prikaziGumb = false;
        }

        //za ispis pocetak
        let n = 1;
        this.podacizaPDF.push([
          {text: 'R.b.', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]}, 
          {text: 'ID', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Korisničko ime', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Ime', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Cijena satnice', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Organ', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]},
          {text: 'Napomena', fillColor: '#edeff2', style: 'tableHeader', border: [false, false, false, true]}
        ]); 
        this.djelatnici.forEach((item) =>{
          //console.log(item);
          this.podacizaPDF.push([
            {text: n+'.', border: [false, false, false, false]},
            {text: item.idDjelatnik, border: [false, false, false, false]},
            {text: item.korisnickoIme, border: [false, false, false, false]},
            {text: item.ime, border: [false, false, false, false]},
            {text: item.cijenaRadaPrikaz, border: [false, false, false, false], alignment: 'right'},
            {text: item.organNaziv, border: [false, false, false, false]},
            {text: item.napomena, border: [false, false, false, false]}
          ]);
          n++;
        });
        //za ispis kraj
        
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }
  
  changeRukovodeci(e) {
    //console.log(e);
    if (e.value === true) {
      this.rukovodeci = true;
      this.rukovodeci_vr = 1;
    }else{
      this.rukovodeci = false;
      this.rukovodeci_vr = 0;
    }
  }

  dodajDjelatnikaPopup() {
    this.djelatnikPopupVisible = true;
    this.djelatnikFormaPoruka = 'Dodavanje!';
    this.korisnickoIme = '';
    this.lozinka = '';
    this.ime = '';
    this.email = '';
    this.aktivan = 'Y';
    this.organ = '';
    this.organNaziv = '';
    this.radnoMjesto = null;
    this.oib = '';
    this.adminStatus = 'Ne';
    this.vrstaStatus = '';
    this.partnerId = null;
    this.cijenaRada = null;
    this.rukovodeci = false;
    this.rukovodeci_vr = 0;
    this.napomena = null;
  }

  dodajDjelatnika() {
    let data = {
      login: this.korisnickoIme,
      lozinka: this.lozinka,
      name: this.ime,
      email: this.email,
      active: this.aktivan,
      activation_code: '',
      // admin: this.adminStatus === 'Da' ? 'Y' : 'N',
      admin: 'N',
      idfirma: 2,
      // vrsta: this.vrstaStatus,
      vrsta: 'P',
      idpartner: null,
      organ: this.organ,
      organnaziv: this.organNaziv,
      // mjestorada: this.radnoMjesto,
      mjestorada: null,
      oib: this.oib,
      cijenarada: this.cijenaRada,
      rukovodeci: this.rukovodeci_vr,
      napomena: this.napomena,
    };
    //console.log(data);
    this.service.dodajDjelatnika(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        if (this.popisAktivnih) {
          this.dohvatiDjelatnike();
        } else {
          this.dohvatiNeaktivneDjelatnike();
        }
        notify('Uspješno dodavanje novog djelatnika.', 'success', 3000);
        this.djelatnikPopupVisible = false;
      } else {
        notify('Došlo je do pogreške! Djelatnik nije dodan!', 'error', 3000);
      }
    });
  }

  urediDjelatnikaPopup(data) {
    this.djelatnikPopupVisible = true;
    this.djelatnikFormaPoruka = 'Uređivanje!';
    //console.log(data.data);
    this.korisnickoIme = data.data.korisnickoIme;
    this.lozinka = data.data.lozinka;
    this.ime = data.data.ime;
    this.email = data.data.email;
    this.aktivan = data.data.aktivan;
    this.organ = data.data.organ;
    this.radnoMjesto = data.data.radnoMjesto;
    this.oib = data.data.oib;
    // this.adminStatus = data.data.admin === 'Y' ? 'Da' : 'Ne';
    this.adminStatus = data.data.admin;
    this.vrstaStatus = data.data.vrsta;
    this.partnerId = data.data.idPartner;
    this.firmaId = data.data.idFirma;
    this.cijenaRada = data.data.cijenaRada;
    if (data.data.rukovodeci == 1) {
      this.rukovodeci = true;
      this.rukovodeci_vr = 1;
    } else {
      this.rukovodeci = false;
      this.rukovodeci_vr = 0;
    }
    this.napomena = data.data.napomena;
    this.idkorisnik2 = data.data.idDjelatnik;
    this.dohvatiGrupe();
  }

  urediDjelatnika() {
    let data = {
      idsec_users: this.idkorisnik2,
      login: this.korisnickoIme,
      lozinka: this.lozinka,
      name: this.ime,
      email: this.email,
      active: this.aktivan,
      activation_code: '',
      admin: this.adminStatus,
      idfirma: this.firmaId,
      vrsta: this.vrstaStatus,
      idpartner: this.partnerId,
      organ: this.organ,
      organnaziv: this.organNaziv,
      mjestorada: this.radnoMjesto,
      oib: this.oib,
      cijenarada: this.cijenaRada,
      rukovodeci: this.rukovodeci_vr,
      napomena: this.napomena,
    };
    //console.log(data);
    this.service.urediDjelatnika(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        if (this.popisAktivnih) {
          this.dohvatiDjelatnike();
        } else {
          this.dohvatiNeaktivneDjelatnike();
        }
        notify('Uspješna promjena podataka.', 'success', 3000);
        this.djelatnikPopupVisible = false;
      } else {
        notify('Došlo je do pogreške! Pokušajte ponovno!', 'error', 3000);
      }
    });
  }

  urediPravoDjelatnikaPopup() {
    this.popupVisible = true;
  }

  dohvatiGrupe() {
    this.sveKorisnickeGrupe = [];
    this.service
      .dohvatiGrupeKorisnika({
        idkorisnik: this.idSecUser,
        idkorisnik2: this.idkorisnik2,
      })
      .subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.sveKorisnickeGrupe = res.data;
        } else {
          this.sveKorisnickeGrupe = [];
        }
      });
  }

  editGrupe(e: any, data: any) {
    //console.log(e.value);
    //console.log(data.data);
    if (e.value === true) {
      //console.log('true');
      this.service
        .grupeKorisnikaEditAdd({
          idkorisnik: this.idSecUser,
          idkorisnik2: this.idkorisnik2,
          idgrupa: data.data.idsec_group,
        })
        .subscribe((res) => {
          //console.log(res);
          this.dohvatiGrupe();
        });
    } else {
      //console.log('false');
      this.service
        .grupeKorisnikaEditDelete({
          idkorisnik: this.idSecUser,
          idkorisnik2: this.idkorisnik2,
          idgrupa: data.data.idsec_group,
        })
        .subscribe((res) => {
          //console.log(res);
          this.dohvatiGrupe();
        });
    }
  }

  odustani() {
    this.popupVisible = false;
  }

  obrisiDjelatnikaPopup(data) {
    // console.log(data.data);
    this.obrisiDjelatnikaPopupVisible = true;
    this.korisnickoIme = data.data.korisnickoIme;
  }

  obrisiDjelatnika() {
    this.service
      .obrisiDjelatnika({ login: this.korisnickoIme })
      .subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.dohvatiDjelatnike();
          notify('Odabrani djelatnik je sada neaktivan.', 'success', 3000);
          this.obrisiDjelatnikaPopupVisible = false;
        } else {
          notify('Došlo je do pogreške! Pokušajte ponovno!', 'error', 3000);
        }
      });
  }

  // ========== RADNA MJESTA ==========
  dohvatiMjestoRada() {
    this.service.dohvatiMjestoRada({}).subscribe((res) => {
      // console.log(res);
      if (res.success === true) {
        for (let mjesto of res.data) {
          this.radnaMjesta.push({
            id: mjesto.idmjestorada,
            naziv: mjesto.mr_djmjestorada,
          });
        }
        // console.log(this.radnaMjesta);
      }
    });
  }

  // ========== ORGANI ==========
  dohvatiOrgan() {
    this.service.dohvatiOrgan({ idkorisnik: this.idSecUser, idfirma: this.idfirma }).subscribe((res) => {
      // console.log(res);
      this.organi = [];
      if (res.success === true) {
        for (let organ of res.data) {
          this.organi.push({
            sifra: organ.or_djorgan,
            naziv: organ.or_djorgannaziv,
          });
        }
        // console.log(this.organi);
      }
    });
  }

  // ========== PARTNERI ==========
  dohvatiPartnere() {
    this.service.dohvatiPartnere({}).subscribe((res) => {
      // console.log(res);
      this.partneri = [];
      if (res.success === true) {
        for (let partner of res.data) {
          this.partneri.push({
            id: partner.pa_id,
            sifra: partner.pa_sifra,
            naziv: partner.pa_naziv,
          });
        }
        // console.log(this.partneri);
      }
    });
  }

  // ========== ON VALUE CHANGE ==========
  onChangeKorisnickoIme(e) {
    this.korisnickoIme = e.value;
  }
  onChangeLozinka(e) {
    this.lozinka = e.value;
  }
  onChangeIme(e) {
    this.ime = e.value;
  
    var znakovi = {
      Č: 'C',
      Ć: 'C',
      Đ: 'D',
      Š: 'S',
      Ž: 'Z',
      č: 'c',
      ć: 'c',
      đ: 'd',
      š: 's',
      ž: 'z'
    }
  
    if (this.korisnickoIme && this.korisnickoIme.trim() !== '') {
      return;
    }
  
    if (this.ime) {
      let lowerCaseString = this.ime.toLowerCase();
      let korIme = lowerCaseString.replace(/ /g, '.');
      this.korisnickoIme = korIme.replace(/Č|Ć|Đ|Š|Ž|č|ć|đ|š|ž/gi, function (matched) {
        return znakovi[matched];
      });
      this.email = this.korisnickoIme + '@pekar.hr';
  
      if (!this.lozinka) {
        this.lozinka = '32100';
      }
    }
  }

  onChangeEmail(e) {
    this.email = e.value;
  }
  onChangeStatus(e) {
    if (e.value) {
      this.aktivan = 'Y';
    } else {
      this.aktivan = 'N';
    }
  }
  onChangeOrgan(e) {
    this.organ = e.value;
    if (e.value) {
      let organ = this.organi.find((organ) => organ.sifra === e.value);
      this.organNaziv = organ.naziv;
    }
  }
  onChangeRadnoMjesto(e) {
    this.radnoMjesto = e.value;
  }
  onChangeOIB(e) {
    this.oib = e.value;
  }
  onChangeAdmin(e) {
    if (e.value) {
      this.adminStatus = 'Da';
    } else {
      this.adminStatus = 'Ne';
    }
  }
  onChangeVrsta(e) {
    this.vrstaStatus = e.value;
  }
  onChangePartner(e) {
    this.partnerId = e.value;
  }
  onChangeCijenaRada(e) {
    this.cijenaRada = e.value;
  }
  onChangeNapomena(e) {
    this.napomena = e.value;
  }

  // ========== UPLOAD DJELATNIKA ==========
  onUploaded(e) {
    //console.log(e);
    let file = e.file;
    let formData: FormData = new FormData();
    // formData.append('idkorisnik', this.params.idkorisnik);
    // formData.append('idfirma', this.params.idfirma);
    // formData.append('access_token', this.params.access_token);
    formData.append('datoteka', file);
    // formData.append('idugovor', this.idUgovor);
    // formData.append('ud_oznaka', '1');
    // formData.append('iddokument', this.idUgovor);
    // formData.append('nazivtablice', 'ugovor');
    this.service.uploadDjelatnika(formData).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.syncDjelatnika();
      }
    });
  }
  syncDjelatnika() {
    this.service.sinkronizirajDjelatnike({}).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiDjelatnike();
        notify('Uspješno dodani djelatnici.', 'success', 3000);
      } else {
        notify(
          'Došlo je do greške! Provjerite format excel tablice!',
          'error',
          3000
        );
      }
    });
  }

  // ========== TABLE OPTIONS ==========
  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    },
    {
      location: 'after',
      template: 'gumb_ispis'
    });
  }
}
